// Main Theme JS File

// import "regenerator-runtime/runtime";
// import "core-js/stable";

// Theme Sections
import './sections/announcement-bar';
import './sections/accordion';
import './sections/article';
import './sections/articles-gallery';
import './sections/collection-filter';
import './sections/contact-form';
import './sections/featured-collections';
import './sections/featured-product';
import './sections/featured-products';
import './sections/footer';
import './sections/lifestyle-product';
import './sections/image-gallery';
import './sections/main-product';
import './sections/main-kit-product';
import './sections/newsletter';
import './sections/header';
import './sections/hero-2';
import './sections/social-callout';
import './sections/stats-callout-v2';
import './sections/story-text-media';
import './sections/product-grid';
import './sections/products-listing-nav';
import './sections/product-recommendations';
import './sections/two-four-up-content';

// Theme Components
import './components/cart';
import './components/MiniCart';

// Load Theme Sections
import { load } from '@shopify/theme-sections';

// Helpers
import CustomerAddresses from './helpers/customer';

load('*');

class App {
  constructor() {
    this.init();
  }

  init() {
    window.addEventListener('load', (event) => {
      // eslint-disable-next-line no-new
      new CustomerAddresses();
    });
  }
}

console.log('testing deployment');

// eslint-disable-next-line no-unused-vars
const app = new App();
